import { Injectable } from '@angular/core';
import { Nevera } from './nevera.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NeverasService {
  constructor(private httpClient: HttpClient) {}

  newNevera(nevera: Nevera): Observable<any> {
    console.log('Registrando nevera: ', nevera);
    const neveraAux: Nevera = Object.assign({}, nevera);
    neveraAux.images = [
      {
        image_path: null,
        preview: null,
        tipo_id: 1,
        sort_id: 1,
      },
    ];

    return this.httpClient.post(environment.apiURL + '/neveras/', neveraAux);
  }

  unlinkImages(neveraID: string): Observable<any> {
    return this.httpClient.delete(
      environment.apiURL + '/neveras/imagenes/unlink/' + neveraID
    );
  }

  uploadImage(
    neveraID: string,
    image: any,
    urlSlug: string,
    tipoID: string,
    sortID: string
  ): Observable<any> {
    console.log('neveraID: ', neveraID);
    console.log('image: ', image);
    urlSlug = urlSlug + '-';
    urlSlug = urlSlug + Math.floor(Math.random() * 100000) + 1;
    console.log('urlSlug: ', urlSlug);
    const neveraData = new FormData();
    neveraData.append('nevera_id', neveraID);
    neveraData.append('tipo_id', tipoID);
    neveraData.append('sort_id', sortID);

    if (typeof image === 'object') {
      neveraData.append('image', image, urlSlug);
    } else {
      neveraData.append('image', image);
    }

    return this.httpClient.post(
      environment.apiURL + '/neveras/imagenes',
      neveraData
    );
  }

  getNeveras(
    currentPage: number,
    pageSize: number,
    fromDate: string,
    toDate: string
  ): Observable<any> {
    const queryParams =
      '?currentpage=' +
      currentPage +
      '&pagesize=' +
      pageSize +
      '&fromdate=' +
      fromDate +
      '&todate=' +
      toDate;
    return this.httpClient.get(environment.apiURL + '/neveras' + queryParams);
  }
  getNeverasLength(fromDate: string, toDate: string): Observable<any> {
    const queryParams = '?fromdate=' + fromDate + '&todate=' + toDate;
    return this.httpClient.get(
      environment.apiURL + '/neveras/length' + queryParams
    );
  }

  getNevera(urlSlug: string): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/neveras/' + urlSlug);
  }
  getImagenes(id: string): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/neveras/imagenes/' + id);
  }

  updateNevera(nevera: Nevera): Observable<any> {
    console.log('Actualizando nevera: ', nevera);

    const neveraAux: Nevera = Object.assign({}, nevera);
    neveraAux.images = [
      {
        image_path: null,
        preview: null,
        tipo_id: 1,
        sort_id: 1,
      },
    ];

    return this.httpClient.patch(environment.apiURL + '/neveras/', neveraAux);
  }
}
